export default "__VITE_ASSET__qi8xmSXSbTWjxzeotr3tRA__"